import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";

export const getContracts = createAsyncThunk(
  "/contractsSlice/get",
  async (_, { rejectWithValue }) => {
    try {
      // authToken eklenecek cookie,local vs biryerden okunup
      const { data, errorMessage, isSuccess } = await commonNetwork.get("/parameters/getAgrementByFirm");
      if (isSuccess ) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (e) {
      return rejectWithValue(e.data.message);
    }
  }
);

export const contractsSlice = createSlice({
  name: "contracts",
  initialState: {
    contracts: [],
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.contracts = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getContracts.fulfilled, (state, { payload }) => {
      state.contracts = payload;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      return state;
    });
    builder.addCase(getContracts.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      // state.errorMessage = payload.message;
    });
    builder.addCase(getContracts.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { changeSheetDetailStatus } = contractsSlice.actions;

export const contractsSelector = (state) => state.contracts;

export const contractsReducer = contractsSlice.reducer;
